export default __webpack_public_path__ + "static/media/at_dark.d94c570b.png";